// extracted by mini-css-extract-plugin
export var actionButton = "_84-0";
export var attachmentLine = "_84-1";
export var fileInput = "_84-2";
export var fileUploadWrapper = "_84-4";
export var footer = "_84-3";
export var modalContent = "_84-5";
export var paperclip = "_84-6";
export var quillEditor = "_84-7";